import { Sidebar } from "./Sidebar";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { select } from "@wordpress/data";
import { STORE_NAME } from "../store";

export const Book = () => {
	const chapters = select( STORE_NAME ).getChapters()
	const { title } = select( STORE_NAME ).getBookData();
	const {author, translator } = select( STORE_NAME ).getProductData();

	return (
		<>
			<div id="left-area">
				<h1 className="mb-5">
					{title}
				</h1>
				<div className="mb-5">
					<div>מאת: {author}</div>
					<div>תרגום: {translator}</div>
				</div>
				<h3>תוכן העניינים</h3>
				{ chapters.map((chapter, index) => (
					<div key={index} className="mb-5">
						<a href={chapter.permalink}><b>{chapter.title}</b></a>
						{chapter.description && <p>{
							parse(DOMPurify.sanitize(chapter.description))
						}</p> }
					</div>
				) ) }
			</div>
			<Sidebar />
		</>
	);
}